var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.33594 17.05859a.99437.99437 0 00-1.11035.3086l-18 22A1.00015 1.00015 0 005 41H23a.99943.99943 0 001-1V18A.99858.99858 0 0023.33594 17.05859zM23 8H5A.99943.99943 0 004 9 10 10 0 0024 9 .99943.99943 0 0023 8zM26.66406 31.94141A.97779.97779 0 0027 32a1.00043 1.00043 0 00.77441-.36719l18-22A1.00015 1.00015 0 0045 8H27a.99943.99943 0 00-1 1V31A.99859.99859 0 0026.66406 31.94141zM36 30A10.01177 10.01177 0 0026 40a.99943.99943 0 001 1H45a.99943.99943 0 001-1A10.01177 10.01177 0 0036 30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/zendesk.8f66e6bbcffd119a30f6e78a05e660cc.svg";
export { ForwardRef as ReactComponent };